var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSortAscending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A36",
    fillRule: "evenodd",
    d: "M7.5 5.833c0-.46.373-.833.833-.833h3.334a.833.833 0 1 1 0 1.667H8.333a.833.833 0 0 1-.833-.834ZM4.167 10c0-.46.373-.833.833-.833h10a.833.833 0 0 1 0 1.666H5A.833.833 0 0 1 4.167 10Zm-2.5 4.167c0-.46.373-.834.833-.834h15a.833.833 0 0 1 0 1.667h-15a.833.833 0 0 1-.833-.833Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortAscending);
export default __webpack_public_path__ + "static/media/icon_sort-ascending.9eda6d519026bf9abc326ea37b200b56.svg";
export { ForwardRef as ReactComponent };